const runOnClientOnly = (fn: () => void) => {
  if (typeof window !== "undefined") {
    fn()
  }
}

export const isClient = typeof window !== "undefined"

export default runOnClientOnly
